<template>
	<div class="cd-badges">
		<!--
		<div v-if="item.status == 5 && item.date_available" class="cd-badge green cd-badge-preorder">
			<span>{{ labels.get('preorder') }}</span>
		</div>
		-->
		<template v-if="item.selected_price != 'promotion2'">
			<span
				v-if="priceRecommended == false && ((isLoyalty == true && item.loyalty_price_custom && item.loyalty_price_custom < item.basic_price_custom && item.type != 'advanced' && item.type != 'configurable') || (item.discount_percent_custom > 0 && item.type != 'advanced' && item.type != 'configurable'))"
				class="cd-badge cd-badge-discount"
				:class="{'inactive': item.price_custom_prices_cart && item.price_custom_prices_cart_expire, 'cd-badge-loyalty': isLoyalty == true && item.loyalty_price_custom && item.loyalty_price_custom < item.price_custom}">
				<span>
					<template v-if="isLoyalty == true && item.loyalty_price_custom && item.loyalty_price_custom < item.price_custom">{{ labels.get('loaylty') }}</template>
					-{{ discountPercent }} %
				</span>
			</span>
			<template v-if="item.type == 'advanced' && item.type_config">
				<!-- FIXME INTEG doraditi badge za popust kod advanced proizvoda -->
				<template v-for="(config, key, index) in item.type_config" :key="key">
					<span
						v-if="config.price_custom > 0 && discountPercentAdvanced[index] && advancedItem && advancedItem == key"
						class="cd-badge cd-badge-discount"
						:class="{'inactive': item.price_custom_prices_cart && item.price_custom_prices_cart_expire, 'cd-badge-loyalty': isLoyalty == true && item.loyalty_price_custom && item.loyalty_price_custom < item.price_custom}">
						<span>
							<template v-if="isLoyalty == true && item.loyalty_price_custom && item.loyalty_price_custom < item.price_custom">{{ labels.get('loaylty') }}</template>
							-{{ discountPercentAdvanced[index] }} %
						</span>
					</span>
				</template>
			</template>
		</template>
		<template v-if="item.badges?.length">
			<template v-for="badge in item.badges" :key="badge.code">
				<template v-if="badge.label_title">
					<span class="cd-badge" :class="['cd-badge-' + badge.code, {'cd-badge-preorder': +badge.category == 1}]">{{ badge.label_title }}</span>
				</template>
			</template>
		</template>
		<div v-if="item.selected_price && item.selected_price == 'uau'" class="cd-badge cd-badge-uau">
			<span>{{ labels.get('uau_badge_title') }}</span>
		</div>
		<span v-if="item.priority_details && item.priority_details.code != 'action'" class="cd-badge cd-badge-new">{{ labels.get('new_badge') }}</span>
	</div>
</template>

<script setup>
	const labels = useLabels();
	const auth = useAuth();
	const props = defineProps(['item', 'advancedItem']);

	//loyalty
	const isLoyalty = computed(() => {
		const user = auth.getUser();
		if(user?.loyalty_code) {
			return true;
		} else {
			return false;
		}
	});

	//recommended price
	const priceRecommended = computed(() => {
		if (
			props.item.selected_price == 'recommended' &&
			(props.item.discount_percent_custom > 0 || props.item.price_custom < props.item.basic_price_custom) &&
			((!props.item.loyalty_price_custom || isLoyalty.value == false) || (isLoyalty.value == true && props.item.loyalty_price_custom && props.item.price_custom < props.item.loyalty_price_custom))
		) {
			return true;
		} else {
			return false;
		}
	});

	//badge discount
	const discountPercent = computed(() => {
		if (props.item.selected_price == 'recommended' && (props.item.discount_percent_custom > 0 || props.item.price_custom < props.item.basic_price_custom) && (isLoyalty.value == true && props.item.loyalty_price_custom && props.item.loyalty_price_custom < props.item.price_custom)) {
			return Math.floor((1 - props.item.loyalty_price_custom / props.item.price_custom) * 100, 0);
		} else if (isLoyalty.value == true && props.item.loyalty_price_custom && props.item.loyalty_price_custom > props.item.basic_price_custom) {
			return Math.floor((1 - props.item.loyalty_price_custom / props.item.basic_price_custom) * 100, 0);
		} else {
			return Math.floor(props.item?.discount_percent_custom);
		}
	});
	const priceSaved = computed(() => {
		if (props.item.selected_price == 'recommended' && (props.item.discount_percent_custom > 0 || props.item.price_custom < props.item.basic_price_custom) && (isLoyalty.value == true && props.item.loyalty_price_custom && props.item.loyalty_price_custom < props.item.price_custom)) {
			return props.item.price_custom - props.item.loyalty_price_custom;
		} else if (isLoyalty.value == true && props.item.loyalty_price_custom && props.item.loyalty_price_custom > props.item.basic_price_custom) {
			return props.item.basic_price_custom - props.item.loyalty_price_custom;
		} else {
			return props.item.basic_price_custom - props.item.price_custom;
		}
	});

	let discountPercentAdvanced = ref([])
</script>

<style lang="less" scoped>
	.cd-badges{
		position: absolute; top: 0; left: 0; display: flex; flex-wrap: wrap; align-items: center; justify-content: flex-start;

		@media (max-width: @m){left: 15px;}
	}
	.cd-badge{
		display: flex; align-items: center; justify-content: center; height: 36px; margin: 0 5px 5px 0; padding: 0 15px; background: @green; font-size: 14px; line-height: 1.4; font-weight: 600; text-transform: uppercase; color: @white; z-index: 1;

		@media (max-width: @t){height: 32px; padding: 0 12px; font-size: 13px;}
		@media (max-width: @m){height: 28px; margin: 0 1px 1px 0; padding: 0 12px; font-size: 12px;}
	}
	.cd-badge-preorder{background: @green;}
	.cd-badge-discount{
		background: @red; font-size: 15px;
		&.inactive{background: #686868;}

		@media (max-width: @t){font-size: 13px;}
	}
	.cd-badge-new, .cd-badge-loyalty{background: @blue;}
	.cd-badge-uau{background: #f57855;}
</style>
